import * as z from "zod";
import { userFacingError } from "../authorization";
import { mutator } from "./mutator";

const revokeConnectorGrantSchema = z.object({
  oauthConnectionId: z.string(),
});

export const revokeConnectorGrant = mutator({
  schema: revokeConnectorGrantSchema,
  resolve: {
    grant: { kind: "oauthConnection", from: "oauthConnectionId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.grant.connectedAppId,
    },
  ],
  fn: async ({ tx, args: { grant } }) => {
    if (!grant.connectedAppId) throw userFacingError("Grant not found");
    await tx.mutate.oauthConnections.delete({ id: grant.id });
  },
});
